import React, { useState } from 'react';
import { BASE_URL } from '../config/constants';
const ResetPassword = () => {
	const [resetPasswordEmail, setResetPasswordEmail] = useState({
		email: '',
	});

	const [message, setMessage] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const handleLogin = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		setMessage('');
		const baseUrl = BASE_URL;
		try {
			const response = await fetch(`${baseUrl}/api/v1/auth/forgot/password`, {
				method: 'POST',
				body: JSON.stringify({ email: resetPasswordEmail.email }),
				headers: { 'Content-Type': 'application/json' },
			});

			if (response.ok) {
				setMessage('Reset successfully! , Check You Email');
			} else {
				setMessage('An error occurred.');
			}
		} catch {
			setMessage('Server error. Please try again later.');
			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className='bg-white'>
			<section className='bg-main h-[40vh] md:h-[50vh] flex justify-center items-center mb-16'>
				<h2 className='text-2xl md:text-5xl text-white font-semibold'>
					Reset Password
				</h2>
			</section>
			<div className='container mb-16 md:w-5/12 '>
				<form className='bg-[#f2f3f5] flex flex-col gap-4 p-6 md:p-6 items-center rounded'>
					<div className='input-group w-full'>
						<input
							className='w-full outline-none p-3 rounded border-[#cedbea] border-[1px] border-solid'
							type='text'
							required
							placeholder='Email'
							value={resetPasswordEmail.email}
							onChange={(e) => {
								setResetPasswordEmail({ email: e.target.value });
							}}
						/>
					</div>
					<div className='input-group w-full'>
						<button
							onClick={handleLogin}
							className={`text-center w-full p-3 rounded text-main font-bold ${
								isLoading ? 'bg-gray-400' : 'bg-secondary'
							}`}>
							{isLoading ? 'Resetting' : 'Reset'}
						</button>
					</div>
					{message && (
						<p
							className={`text-sm ${
								message.includes('successfully')
									? 'text-green-600'
									: 'text-red-700'
							}`}>
							{message}
						</p>
					)}
				</form>
			</div>
		</div>
	);
};

export default ResetPassword;
